import router, { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useConfig } from '../providers/config'
import { useSalesAgentData } from '../providers/sales-agent'
import { useStore } from '../providers/store'
import { useUserData } from '../providers/user'
import { redirectToLogin as restrictionRedirectToLogin } from '../restriction'

export const useRestrictions = () => {
	const { restriction } = useConfig()
	const { isLoggedIn: isCustomerLoggedIn } = useUserData()
	const { isLoggedIn: isSalesAgentLoggedIn } = useSalesAgentData()
	const store = useStore()
	const { asPath, pathname } = useRouter()

	useEffect(() => {
		const restrictionRedirect = restrictionRedirectToLogin({
			isCustomerLoggedIn,
			isSalesAgentLoggedIn,
			store,
			restrictionConfig: restriction,
			pathname,
			asPath,
		})

		if (restrictionRedirect) {
			const { destination } = restrictionRedirect
			router.push(destination)
		}
	}, [isCustomerLoggedIn, isSalesAgentLoggedIn, restriction, store, asPath, pathname])
}
